export default "__VITE_ASSET__BySnDSOf__"